import React from "react";
import { FaPaperPlane } from "react-icons/fa";

const Acao = ({ notifyColor = "#51a197", selected, setSelected, isMobile = false, onProximo }) => {
  return (
    <div style={{ padding: 12 }}>
      <div
        onClick={() => setSelected && setSelected("Enviar Mensagem")}
        role="button"
        tabIndex={0}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: 12,
          borderRadius: 10,
          border: `1px solid ${notifyColor}`,
          background: selected === "Enviar Mensagem" ? notifyColor : "#fff",
          color: selected === "Enviar Mensagem" ? "#fff" : "#333",
          cursor: "pointer",
          maxWidth: 420,
        }}
      >
        <input
          type="radio"
          name="acao"
          checked={selected === "Enviar Mensagem"}
          onChange={() => setSelected && setSelected("Enviar Mensagem")}
          style={{ width: 18, height: 18, accentColor: notifyColor }}
        />

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <FaPaperPlane style={{ fontSize: 18, color: selected === "Enviar Mensagem" ? "#fff" : notifyColor }} />
          <div style={{ fontWeight: 600 }}>Enviar Mensagem</div>
        </div>
      </div>

      {isMobile && (
        <div style={{ marginTop: 12, display: "flex", justifyContent: "center" }}>
          <button
            onClick={() => onProximo && onProximo()}
            disabled={selected !== "Enviar Mensagem"}
            style={{
              background: selected !== "Enviar Mensagem" ? "#ccc" : notifyColor,
              color: "#fff",
              border: "none",
              borderRadius: 10,
              padding: "12px 22px",
              fontWeight: "700",
              fontSize: 18,
              cursor: selected !== "Enviar Mensagem" ? "not-allowed" : "pointer",
              opacity: selected !== "Enviar Mensagem" ? 0.6 : 1,
              transition: "background 0.2s",
              width: "90%",
              maxWidth: 420,
            }}
          >
            Próximo
          </button>
        </div>
      )}
    </div>
  );
};

export default Acao;
